import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IVolunteerShifts } from '../interfaces/community.interface';

export interface ReopenDialogConfig {
  volunteerShifts: IVolunteerShifts[];
  isTicket?: boolean;
  onConfirm: (shifts: IVolunteerShifts[], quantity: number | null) => void;
  onCancel: () => void;
}

@Injectable({ providedIn: 'root' })
export class ReopenParticipationDialogService {
  private _isOpen = new BehaviorSubject<boolean>(false);
  private _config = new BehaviorSubject<ReopenDialogConfig | null>(null);

  public isOpen$ = this._isOpen.asObservable();
  public config$ = this._config.asObservable();

  openDialog(config: ReopenDialogConfig): void {
    this._config.next(config);
    this._isOpen.next(true);
  }

  closeDialog(): void {
    this._isOpen.next(false);
    this._config.next(null);
  }

  get currentConfig(): ReopenDialogConfig | null {
    return this._config.value;
  }
}
